import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Eye, EyeOff } from '@digital-twins/design-system/icons'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type InputProps = React.ComponentPropsWithoutRef<typeof Input>

interface PasswordInputProps extends Omit<InputProps, 'type'> {}

export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const { t } = useTranslation('common')
  const [show, setShow] = useState(false)

  return (
    <div className="relative">
      <Input
        {...props}
        type={show ? 'text' : 'password'}
        className={cn('pr-10', className)}
      />
      <button
        type="button"
        onClick={() => setShow((prev) => !prev)}
        aria-label={show ? t('hidePassword') : t('showPassword')}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground transition-colors hover:text-foreground"
        tabIndex={-1}
      >
        {show ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  )
}
